import { RadioButton } from 'Components/RadioButton';
import { withList } from '../../hoc';

export default withList(RadioButton);
